import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import { AlertHeader, Header, Label, StyledDeviceIcon, TimestampCnt, TooltipContainer } from './styles';
import { momentFormat } from '#helper';

/**
 * Renders device info.
 */

const DevicesTooltip = props => {
  const { properties, devices, account, dateRange } = props;
  const uids = useMemo(() =>
    Object.values(devices.reduce((a, c) => {
      if (properties[c.uid]) {
        a[c.uid] = ({
          uid: c.uid,
          label: c.title,
          count: properties[c.uid],
          icon: c.type,
          excursion:
            properties.tempExcursionUids.includes(c.uid) ||
            properties.humiExcursionUids.includes(c.uid) ||
            properties.batExcursionUids.includes(c.uid)
        });
      }
      return a;
    }, {})), [devices, properties]);

  return (
    <TooltipContainer>
      {properties.tempExcursion ?
        <AlertHeader>
          <NotificationsActiveRoundedIcon />
          Temperature excursion
        </AlertHeader> : null}
      {properties.humiExcursion ?
        <AlertHeader>
          <NotificationsActiveRoundedIcon />
          Humidity excursion
        </AlertHeader> : null}
      {properties.batExcursion ?
        <AlertHeader>
          <NotificationsActiveRoundedIcon />
          Battery excursion
        </AlertHeader> : null}
      {properties.firstLocation ?
        <Header>
          <DoubleArrowRoundedIcon />
          First geo-position
        </Header> : null}
      {properties.lastLocation ?
        <Header>
          <LocationOnRoundedIcon />
          Last geo-position
        </Header> : null}
      <TimestampCnt color="textSecondary">
        First at:&nbsp;
        {momentFormat(dateRange.first, account, 'dateTimePartial')}
        <br />
        Last at:&nbsp;
        {momentFormat(dateRange.last, account, 'dateTimePartial')}
      </TimestampCnt>
      {uids.map(t =>
        <Label alert={t.excursion} key={t.uid}>
          <StyledDeviceIcon icon={t.icon} />
          <Typography component="p" color="textSecondary">{t.label}</Typography>
        </Label>)}
    </TooltipContainer>
  );
};

export default DevicesTooltip;
